import React, { useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton';
import SettingsEthernet from '@material-ui/icons/SettingsEthernet'
import Menu from '@material-ui/core/Menu';

function FieldInserts ({ insertEntity }) {

    const [anchorEl, setAnchorEl] = useState(null);

    const fieldInserts = [
        { text: '<<First Name>>' },
        { text: '<<Last Name>>' }
    ];

    const open = Boolean(anchorEl);

    const close = () => setAnchorEl(null);

    const handleClick = (e) => setAnchorEl(e.currentTarget);
    
    const handleSelect = (e) => {
        e.preventDefault();
        insertEntity(fieldInserts[e.target.value], 'FIELD_INSERT');
        close();
    };

    return (
        <>
            <IconButton onClick={handleClick}><SettingsEthernet /></IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={close}
            >
                {fieldInserts.map((field, i) => {
                    return (
                        <MenuItem key={i} onClick={handleSelect} value={i}>
                            {field.text}
                        </MenuItem>
                    );
                })}
            </Menu>

        </>
    );
};

export default FieldInserts;
